import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Button, Dropdown, Menu } from 'antd'
import { FilePdfOutlined, FileWordOutlined } from '@ant-design/icons'
import PropTypes, { object, string, func, bool, number } from 'prop-types'
import { createSession } from '~/states/modules/analytics'
import VirtualAssistant from '~/components/virtualAssistent'
import DocumentReviewer from '~/components/documentReviewer'
import NotificationLogModal from '~/pages/contracts/components/notificationLogModal'
import api from '~/services/api'
import { errorMessage } from '~/services/messager'
import { getDocumentWordDownload } from '~/states/modules/documentDetail'

const HeaderButtons = ({
	id,
	history,
	infos,
	onDownload,
	onUpdate,
	textUpdate,
	text,
	loadingVersion,
	hasContextAi,
}) => {
	const { versions, text_type, sent } = infos
	const dispatch = useDispatch()

	const { documentDetail } = useSelector(({ contextAi }) => contextAi)
	// const loadingDocx = useSelector((state) => state.documentDetail.loading)

	const [loadingPreviousMessages, setloadingPreviousMessages] = useState(false)
	const [previousMessages, setPreviousMessages] = useState(null)
	const [isAssistantOpen, setIsAssistantOpen] = useState(false)
	const [isReviewerOpen, setIsReviewerOpen] = useState(false)
	const [isNotificationLogOpen, setIsNotificationLogOpen] = useState(false)

	const handleEdit = () => {
		dispatch(createSession('edit'))
		history.push({
			pathname: `/documents/${id}/edit`,
			state: { current: 0 },
		})
	}

	const [isEditable, setIsEditable] = useState(false)

	useEffect(() => {
		if (versions && text_type === '.txt') {
			const editable = !versions.some(
				(version) => version.only_updated_variables === undefined
			)

			setIsEditable(editable)
		}

		if (text_type === '.docx') setIsEditable(true)
		if (text_type === 'upload') setIsEditable(true)
	}, [versions, setIsEditable, text_type])

	const [isUpdatable, setIsUpdatable] = useState(false)

	useEffect(() => {
		if (text_type === '.txt') {
			if (text !== textUpdate.text) {
				setIsUpdatable(true)
			} else {
				setIsUpdatable(false)
			}
		}
	}, [text_type, setIsUpdatable, text, textUpdate])

	useEffect(() => {
		if (
			window.$chatwoot &&
			typeof window.$chatwoot.toggleBubbleVisibility === 'function'
		) {
			const visibility = isAssistantOpen ? 'hide' : 'show'
			try {
				window.$chatwoot.toggleBubbleVisibility(visibility)
			} catch (error) {
				console.log('Chatwoot widget not ready to be toggled yet.', error)
			}
		}
	}, [isAssistantOpen])

	const openAssistant = () => {
		if (previousMessages === null) {
			if (Object.keys(documentDetail).includes(`${id}`)) {
				const payload = {
					thread_id: documentDetail[`${id}`],
				}
				setloadingPreviousMessages(true)
				api
					.post('/ai/', payload)
					.then((response) => {
						setloadingPreviousMessages(false)
						const data = response.data
						setPreviousMessages(data.answer)
					})
					.catch((error) => {
						setloadingPreviousMessages(false)
						errorMessage({
							content:
								'Houve um erro na comunicação. \n Por favor, tente novamente mais tarde.',
						})
					})
			}
		}
		setIsAssistantOpen(true)
	}

	const closeAssistant = () => {
		setIsAssistantOpen(false)
	}

	const exportText = (text) => {
		console.log('Exporting text:', text)
	}

	const handleDownloadDocx = () => {
		dispatch(getDocumentWordDownload({ id: id, filename: `minuta_${id}.docx` }))
	}

	const downloadMenu = (
		<Menu>
			<Menu.Item
				key="pdf"
				onClick={(e) => onDownload(e.domEvent)}
				icon={<FilePdfOutlined style={{ color: '#cf1322' }} />}>
				Baixar como PDF
			</Menu.Item>
			<Menu.Item
				key="docx"
				onClick={handleDownloadDocx}
				icon={<FileWordOutlined style={{ color: '#096dd9' }} />}>
				Baixar como Word (DOCX)
			</Menu.Item>
		</Menu>
	)

	return (
		<div style={{ display: 'flex', justifyContent: 'flex-end', gap: 15 }}>
			<Button onClick={handleEdit} disabled={sent || !isEditable}>
				Editar Informações
			</Button>
			{text_type === '.txt' && (
				<Button
					disabled={sent || loadingVersion || !isUpdatable}
					onClick={() => onUpdate(textUpdate)}>
					Salvar modificações
				</Button>
			)}

			<Dropdown.Button
				overlay={downloadMenu}
				onClick={onDownload}
				trigger={['hover', 'click']}>
				Baixar Documento
			</Dropdown.Button>

			{(text_type === 'upload' || hasContextAi) && (
				<Button onClick={openAssistant}>Assistente Virtual</Button>
			)}
			<Button onClick={() => setIsReviewerOpen(true)}>
				Revisor de Contratos{' '}
				<sup
					style={{
						fontSize: '0.6rem',
						fontWeight: 600,
						color: '#002880',
						letterSpacing: '0.03em',
						verticalAlign: 'super',
						lineHeight: 1,
					}}>
					BETA
				</sup>
			</Button>
			<Button onClick={() => setIsNotificationLogOpen(true)}>
				Notificações Enviadas
			</Button>
			<NotificationLogModal
				showModal={isNotificationLogOpen}
				handleCancel={() => setIsNotificationLogOpen(false)}
				documentId={id}
			/>
			<DocumentReviewer
				open={isReviewerOpen}
				onClose={() => setIsReviewerOpen(false)}
				docId={id}
				docTitle={infos?.title}
				docText={text}
			/>
			<VirtualAssistant
				open={isAssistantOpen}
				onClose={closeAssistant}
				exportText={exportText}
				loadingPreviousMessages={loadingPreviousMessages}
				previousMessages={previousMessages}
				doc_type={'documentDetail'}
			/>
		</div>
	)
}

export default HeaderButtons

HeaderButtons.propTypes = {
	id: PropTypes.oneOfType([number, string]),
	history: object,
	infos: object,
	onDownload: func,
	onUpdate: func,
	textUpdate: object,
	text: string,
	loadingVersion: bool,
	hasContextAi: bool,
}
